import { authAPI } from "../auth/auth";

export const adminPricesApi = {
    async getPrices(regionID, packageType, senderCityWithOfficeID) {
        let error;

        if (!regionID || !packageType || !senderCityWithOfficeID) return;
    
        const resp = await fetch(
            `/api/calculator/prices?region-id=${regionID}&package-type=${packageType}&sender-city-with-office-id=${senderCityWithOfficeID}`
        ).catch(e => error = e);

        if(resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.getPrices();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized"
                }
            }
        }

        const data = await resp.json().catch(e => error = e);
        if (error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if (!data) {
            return {
                ok: false,
                err: "unable to parse response"
            }
        }


        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }

        return {
            ok: true,
            prices: data.prices
        }
    },
    async deletePrice(priceID) {
        if (!(+priceID)) return {
            ok: false,
            err: "invalid priceID"
        };

        let error;
        const resp = await fetch(
            `/api/calculator/delete-price/${+priceID}`,
            {
                method: "DELETE"
            }
        ).catch(e => error = e);

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.deletePrice();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized",
                }
            }
        }

        const data = await resp.json().catch(e => error = e);
        
        if (error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if (!data) {
            return {
                ok: false,
                err: "unable to parse response",
            }
        }

        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }

        return {
            ok: true,
        }
    },
    async updatePrice(priceID, price) {
        if (!priceID || !+price) {
            return {
                ok: false,
                err: "invalid price or priceID"
            };
        }

        let body = {
            "price-id": +priceID,
            price: parseInt(price)
        };

        let error;
        const resp = await fetch(`/api/calculator/update-price/`, {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
            },
        }).catch((e) => {
            error = e;
        });

        if(resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.updatePrice();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized"
                }
            }
        }

        const data = await resp.json().catch((e) => {
            error = e;
        });

        if (error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if (!data) {
            return {
                ok: false,
                err: "unable to parse response",
            }
        }

        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }

        return {
            ok: true,
            price: data.price,
        }
    },
    async createPrice(regionID, packageType, senderCityWithOfficeID, weight, price) {
        let body = {
            "region-id": +regionID,
            "package-type": packageType,
            "sender-city-with-office-id": +senderCityWithOfficeID,
            weight: +weight,
            price: parseInt((+price) * 100)
        }

        let error
        let resp = await fetch("/api/calculator/create-price", {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        }).catch(e => error = e)


        if(resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.createPrice();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized"
                }
            }
        }

        let data = await resp.json().catch(e => error = e)

        if(error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if(!data) {
            return {
                ok: false,
                err: "unable to parse response"
            }
        }

        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }

        return {
            ok: true,
            price: data.price
        }
    },
    async getOverPrices(regionID, packageType, senderCityWithOfficeID) {
        if (!regionID || !packageType || !senderCityWithOfficeID) return;

        let error;
        const resp = await fetch(
            `/api/calculator/over-prices?region-id=${regionID}&package-type=${packageType}&sender-city-with-office-id=${senderCityWithOfficeID}`
        ).catch(e => error = e);

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.getOverPrices();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized",
                }
            }
        }

        const data = await resp.json().catch(e => error = e);
        
        if (error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if (!data) {
            return {
                ok: false,
                err: "unable to parse response",
            }
        }

        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }


        return {
            ok: true,
            overPrices: data["over-prices"],
        }
    },
    async deleteOverPrice(overPriceID) {
        if (!(+overPriceID)) return {
            ok: false,
            err: "invalid overPriceID"
        };

        let error;
        const resp = await fetch(
            `/api/calculator/delete-over-price/${+overPriceID}`,
            {
                method: "DELETE"
            }
        ).catch(e => error = e);

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.deleteOverPrice();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized",
                }
            }
        }

        const data = await resp.json().catch(e => error = e);
        
        if (error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if (!data) {
            return {
                ok: false,
                err: "unable to parse response",
            }
        }

        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }

        return {
            ok: true,
        }
    },
    async updateOverPrice(priceID, price) {
        
        if (!priceID || !+price) return;

        let body = {
            "over-price-id": +priceID,
            price: parseInt(+price),
        };

        let error;
        const resp = await fetch(`/api/calculator/update-over-price/`, {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
            },
        }).catch((e) => {
            error = e;
        });


        if(resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.updateOverPrice();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized"
                }
            }
        }

        const data = await resp.json().catch((e) => {
            error = e;
        });

        if (error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if (!data) {
            return {
                ok: false,
                err: "unable to parse response",
            }
        }

        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }

        return {
            ok: true,
            overPrice: data["over-price"],
        }
    },
    async createOverPrice(regionID, packageType, senderCityWithOfficeID, weight, price) {
        let body = {
            "region-id": +regionID,
            "package-type": packageType,
            "sender-city-with-office-id": +senderCityWithOfficeID,
            weight: +weight,
            "over-price": parseInt((+price) * 100)
        }

        let error
        let resp = await fetch("/api/calculator/create-over-price", {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        }).catch(e => error = e)


        if(resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return this.createPrice();
            } else {
                return {
                    ok: false,
                    err: "Unauthorized"
                }
            }
        }

        let data = await resp.json().catch(e => error = e)

        if(error) {
            return {
                ok: false,
                err: "something_went_wrong",
            }
        }

        if(!data) {
            return {
                ok: false,
                err: "unable to parse response"
            }
        }

        if(!data.ok) {
            return {
                ok: false,
                err: data.err ?? "resp.ok is false",
            }
        }

        return {
            ok: true,
            "over-price": data["over-price"]
        }
    },
}